import { render, staticRenderFns } from "./MedicationHistory.vue?vue&type=template&id=16e186f0&scoped=true&"
import script from "./MedicationHistory.vue?vue&type=script&lang=ts&"
export * from "./MedicationHistory.vue?vue&type=script&lang=ts&"
import style0 from "./MedicationHistory.vue?vue&type=style&index=0&id=16e186f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e186f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDataTable,VIcon,VImg,VRow,VSpacer})
